import {Directive, Input, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[appIdViewRef]'
})
export class IdViewRefDirective {
    @Input() id: string = '';

    constructor(public viewContainerRef: ViewContainerRef) {
    }

}

